import React from 'react';
import { useFormatter } from '../../../../core/formatter/use-formatter';
import { useContainer } from '../../../../modules/article/hooks/use-container';
import { Typography } from '../../../typography/typography';
import { WEIGHT_UNIT } from '../../../../domain/article/services/weight';
import { Container } from '../../../../modules/backend/openapi/api-types';
import styles from './table-cell-container.module.scss';

type Props = {
  nItems: number;
  container: Container | number;
  unit?: string;
};

export const TableCellContainer: React.FC<Props> = ({ unit = WEIGHT_UNIT, nItems, container }) => {
  const { formatWeight } = useFormatter();
  const { mapContainer } = useContainer();

  // TODO: implementation for 'number' has to be revisited after R1 / when invoice is implemented
  let usedContainer: string | number;
  if (typeof container === 'number') {
    usedContainer = formatWeight(container);
  } else {
    const mappedContainer = mapContainer(container);
    usedContainer = mappedContainer.weight;
  }

  return (
    <div className={styles.root}>
      <>
        <Typography color="black" variant="maintext">
          {`${nItems} × ${usedContainer}`}
        </Typography>
        <Typography color="anthrazit-75" variant="maintext">
          {`${unit}`}
        </Typography>
      </>
    </div>
  );
};
